export default __webpack_public_path__ + "static/media/cf-nepal-banner.3f5ffcda.jpg";